import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const githubAuthCheckerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'github-auth-checker-form-field-extension',
    params: {
      field: () =>
        import('./github-auth-checker').then(m => m.GithubAuthCheckerFormField),
    },
  });
